import Container from "@/components/ui/Container";
import SectionHeader from "@/components/ui/SectionHeader";
import useInView from "@/hooks/useInView";

const steps = [
  {
    title: "Вопрос в чат",
    desc: "Сотрудник формулирует задачу или вопрос на естественном языке",
  },
  {
    title: "Система собирает данные",
    desc: "MCP находит нужную информацию во всех разделах платформы Ключ-АСТРОМ",
  },
  {
    title: "Анализ и выводы",
    desc: "Формируется единая картина с учётом взаимосвязей — система показывает причину и контекст ситуации",
  },
  {
    title: "Готовый ответ",
    desc: "Получаете понятный результат — что произошло, на что это влияет и рекомендации для действий",
  },
];

const badgeClass =
  "relative z-10 flex size-[44px] shrink-0 items-center justify-center rounded-lg bg-[#1c3564] text-[16px] font-bold text-[#e85e57]";

const titleClass =
  "text-[21px] font-bold leading-none tracking-[-0.21px] text-[#1c3564]";

const descClass =
  "mt-[22px] text-[16px] font-medium leading-[1.3] text-[#202020]";

const fillDelays = ["", "delay-[250ms]", "delay-[500ms]"];

function Connector({ orientation, delay, active }) {
  const isHorizontal = orientation === "horizontal";

  const track = isHorizontal
    ? "left-[22px] top-[22px] h-[5px] w-[calc(100%+20px)] -translate-y-1/2"
    : "-bottom-10 left-[22px] top-[44px] w-[5px] -translate-x-1/2";

  const fill = isHorizontal
    ? `origin-left ${active ? "scale-x-100" : "scale-x-0"}`
    : `origin-top ${active ? "scale-y-100" : "scale-y-0"}`;

  return (
    <span
      className={`absolute overflow-hidden rounded-full bg-surface ${track}`}
    >
      <span
        className={`block h-full w-full rounded-full bg-[#1c3564] transition-transform duration-700 ease-out motion-reduce:!scale-100 motion-reduce:transition-none ${fill} ${delay}`}
      />
    </span>
  );
}

export default function HowItWorksSection() {
  const [ref, inView] = useInView();

  return (
    <section>
      <Container>
        <SectionHeader
          label="Как это работает?"
          heading="Переход от вопроса к решению — за минуты"
        />

        <div ref={ref}>
          {/* Vertical timeline */}
          <div className="mt-[60px] flex flex-col gap-10 xl:hidden">
            {steps.map((step, i) => (
              <div
                key={step.title}
                className="flex gap-[35px] min-[478px]:gap-10"
              >
                <div className="relative shrink-0">
                  {i < steps.length - 1 && (
                    <Connector
                      orientation="vertical"
                      delay={fillDelays[i]}
                      active={inView}
                    />
                  )}
                  <span className={badgeClass}>{i + 1}</span>
                </div>
                <div>
                  <h3 className={titleClass}>{step.title}</h3>
                  <p className={descClass}>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Horizontal timeline */}
          <div className="mt-[90px] hidden xl:block">
            <div className="grid grid-cols-4 gap-5">
              {steps.map((step, i) => (
                <div key={step.title} className="relative">
                  {i < steps.length - 1 && (
                    <Connector
                      orientation="horizontal"
                      delay={fillDelays[i]}
                      active={inView}
                    />
                  )}
                  <span className={badgeClass}>{i + 1}</span>
                </div>
              ))}
            </div>
            <div className="mt-[44px] grid grid-cols-4 gap-5">
              {steps.map((step) => (
                <div key={step.title}>
                  <h3 className={titleClass}>{step.title}</h3>
                  <p className={descClass}>{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
